import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { WhiteButton, Button, Modal } from 'components';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IModalAction } from 'models/modal';
import { IStore } from 'redux/IStore';
import { IArticle } from 'models/magazine/article/article';
import { ItemsSelector } from '../../../../Common/ItemsSelector';
import { SearchUsage } from 'models';
import { IUserPreferences } from 'models/user/userpreferences';
const { connect } = require('react-redux');
require('./style.css');

interface IProps {
	manageArticleFormValues?: IArticle;
	userPreferences?: IUserPreferences;

	/* func props */
	t?: (key: string, object?: any) => string;
	onCancelItemsSelector?: () => void;
	onItemsSelectorSave?: () => void;
	onRemoveItem?: (index: number) => void;
	onSelectItemObject?: (item: IProductListItemCard) => void;
	closeModal?: () => IModalAction;
}

@connect(
	(state: IStore) => ({
		manageArticleFormValues: state.form[c.FORM_NAME_MANAGE_ARTICLE].values,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ArticleFeaturedProductsSelectorModal extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t, manageArticleFormValues } = this.props;

		return (
			<div className="wrapperModalOutfitArticle">
				<Modal showHeaderCloseButton={false} closeModal={this.props.closeModal}>
					<div className="wrapperHeader">
						<div className="container topHeaderModal">
							<WhiteButton onClick={this.props.onCancelItemsSelector}>{t('BSPortal_Common_Back')}</WhiteButton>
							<div className="wrapperRightSideButtons">
								<WhiteButton onClick={this.props.onCancelItemsSelector}>{t('BSPortal_Common_Cancel')}</WhiteButton>
								<Button onClick={this.props.onItemsSelectorSave}>{t('BSPortal_Common_Save')}</Button>
							</div>
						</div>
						<div className="wrapperHeaderBottom">
							<ItemsSelector
								items={[...manageArticleFormValues.itemsJArray]}
								onRemoveItem={this.props.onRemoveItem}
								onSelectItemObject={this.props.onSelectItemObject}
								hideWardrobeItemsTab={true}
								hideWishlistTab={true}
								selectedTab={c.ITEMS_SELECTOR_TAB_PRODUCT}
								productsSeachUsage={SearchUsage.ProductsSearch}
								wardrobeItemsSearchUsage={null}
								userId={this.props.userPreferences.id}
							/>
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export { ArticleFeaturedProductsSelectorModal };
